// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1hEGg","rootSmall":"AddTileButton_rootSmall__3KaIv"};